(() => {
  const pendingKey = 'senseuni.quote.pending.v1';
  const sentKey = 'senseuni.quote.sent.v1';
  const pendingLifetime = 30 * 60 * 1000;
  const leadTypes = {
    'YEPZI Smart Coolers': 'yepzi',
    'SenseUni AI Kit': 'oem',
    'Partnership or other': 'partnership'
  };
  const models = {
    'YEPZI Slim': 'slim',
    'YEPZI Standard': 'standard',
    'YEPZI Standard Media': 'standard_media'
  };
  const readPending = () => {
    try { return JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); }
    catch (_) { return null; }
  };
  const clearPending = () => {
    try { sessionStorage.removeItem(pendingKey); } catch (_) { }
  };
  const rememberSubmission = form => {
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
    const interest = form.querySelector('input[name="contact[Interest]"]:checked');
    const model = form.querySelector('[data-suq-model]');
    const pending = {
      id: (window.crypto && typeof window.crypto.randomUUID === 'function')
        ? window.crypto.randomUUID()
        : String(Date.now()) + '-' + Math.random().toString(36).slice(2),
      createdAt: Date.now(),
      leadType: leadTypes[interest && interest.value] || 'unknown',
      model: models[model && model.value] || 'undecided'
    };
    try { sessionStorage.setItem(pendingKey, JSON.stringify(pending)); } catch (_) { }
  };
  const recordSuccessfulSubmission = () => {
    const pending = readPending();
    if (!pending || typeof pending.id !== 'string' || !Number.isFinite(pending.createdAt)) return;
    const age = Date.now() - pending.createdAt;
    if (age < 0 || age > pendingLifetime) { clearPending(); return; }
    if (typeof window.gtag !== 'function') return;
    try {
      if (sessionStorage.getItem(sentKey) === pending.id) { clearPending(); return; }
    } catch (_) { return; }
    window.gtag('event', 'generate_lead', {
      form_id: 'SenseUniQuoteForm',
      lead_type: ['yepzi', 'oem', 'partnership'].includes(pending.leadType) ? pending.leadType : 'unknown',
      model: ['slim', 'standard', 'standard_media'].includes(pending.model) ? pending.model : 'undecided'
    });
    try { sessionStorage.setItem(sentKey, pending.id); } catch (_) { }
    clearPending();
  };

  const init = () => {
    const form = document.getElementById('SenseUniQuoteForm');
    if (!form || form.dataset.quoteReady) return;
    form.dataset.quoteReady = 'true';
    const params = new URLSearchParams(location.search);
    const aliases = {
      'yepzi slim': 'YEPZI Slim', 'slim': 'YEPZI Slim', 'yepzi sr480': 'YEPZI Slim', 'sr480': 'YEPZI Slim', 'yepzi 480': 'YEPZI Slim', 'yapzi 480': 'YEPZI Slim',
      'yepzi standard': 'YEPZI Standard', 'standard': 'YEPZI Standard', 'yepzi sr608': 'YEPZI Standard', 'sr608': 'YEPZI Standard', 'yepzi 608': 'YEPZI Standard', 'yapzi 608': 'YEPZI Standard',
      'yepzi standard media': 'YEPZI Standard Media', 'standard media': 'YEPZI Standard Media', 'yepzi sr608 media': 'YEPZI Standard Media', 'sr608 media': 'YEPZI Standard Media', 'yepzi 608 media': 'YEPZI Standard Media', 'yapzi 608 media': 'YEPZI Standard Media'
    };
    const model = form.querySelector('[data-suq-model]');
    const initialModel = aliases[(params.get('model') || '').trim().replace(/\s+/g, ' ').toLowerCase()];
    if (model && initialModel) model.value = initialModel;
    const interests = { yepzi: 'YEPZI Smart Coolers', kit: 'SenseUni AI Kit', oem: 'SenseUni AI Kit', partner: 'Partnership or other' };
    const selectedInterest = interests[params.get('interest')];
    if (selectedInterest) form.querySelectorAll('input[name="contact[Interest]"]').forEach(radio => { radio.checked = radio.value === selectedInterest; });
    const source = document.createElement('input');
    source.type = 'hidden';
    source.name = 'contact[Model source]';
    source.value = initialModel ? 'Model page or model link' : 'Quote page';
    form.append(source);
    const error = form.querySelector('.suq-errors');
    const success = form.querySelector('[data-suq-success]');
    if (error) clearPending();
    if (success) recordSuccessfulSubmission();
    else form.addEventListener('submit', () => rememberSubmission(form));
    // Submit feedback (2026-10-28): instant disabled + spinner state so users
    // know the submission is in flight; also blocks double submits (e.g. Enter
    // pressed twice) while the synchronous POST is still pending.
    const submitButton = form.querySelector('button[type="submit"]');
    const resetButton = () => {
      if (!submitButton || form.dataset.submitting !== 'true') return;
      form.dataset.submitting = '';
      submitButton.disabled = false;
      if (submitButton.dataset.originalHtml) submitButton.innerHTML = submitButton.dataset.originalHtml;
    };
    form.addEventListener('submit', event => {
      if (form.dataset.submitting === 'true') { event.preventDefault(); return; }
      form.dataset.submitting = 'true';
      if (submitButton) {
        submitButton.dataset.originalHtml = submitButton.innerHTML;
        submitButton.disabled = true;
        submitButton.innerHTML = '<span class="suq-spinner" aria-hidden="true"></span> Sending\u2026';
      }
    });
    window.addEventListener('pageshow', event => { if (event.persisted) resetButton(); });
    (error || success)?.focus({ preventScroll: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();


